export const contactDataObj = {
  id: "contact",
  description:
    "We are NeuroTX,  a student team from Aachen, Germany aiming to cultivate a learning environment and  hands-on experience in the field of neurotechnology",
  waveImage: require("../../images/waves.png"),
  smallWaveImg: require("../../images/image 3.png"),
  redBgPoint: require("../../images/square.png"),
  coverphoto: require("../../images/coverphoto.png"),
  paypalImage: require("../../images/PaypalButton.png"),
};
